import React, { useState, useMemo } from "react";
import { TextField, MenuItem, Box, Typography, Button as MuiButton } from "@material-ui/core";
import { CloudUpload as CloudUploadIcon } from "components/MaterialSymbol/MaterialIcons";
import Button from "components/CustomButtons/Button.js";

export default function DealerInventoryUploadForm({ makes = [], onClose, onConfirm }) {
    const [selectedMake, setSelectedMake] = useState("");
    const [file, setFile] = useState(null);

    const uniqueMakes = useMemo(() => {
        const seen = new Set();
        return makes.filter((make) => {
            if (seen.has(make.slug)) return false;
            seen.add(make.slug);
            return true;
        });
    }, [makes]);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleConfirm = () => {
        if (selectedMake && file) {
            onConfirm(selectedMake, file);
            onClose();
        }
    };

    const isConfirmDisabled = !selectedMake || !file;

    return (
        <>
            <TextField
                select
                label="Select a Make"
                variant="outlined"
                size="small"
                fullWidth
                value={selectedMake}
                onChange={(e) => setSelectedMake(e.target.value)}
                style={{ marginBottom: 16 }}
            >
                {uniqueMakes.map((make) => (
                    <MenuItem key={make.slug} value={make.slug}>
                        {make.name}
                    </MenuItem>
                ))}
            </TextField>

            <Box mt={1} textAlign="center">
                <input
                    accept=".xlsx,.xls"
                    id="upload-inventory-file"
                    type="file"
                    hidden
                    onChange={handleFileChange}
                />
                <label htmlFor="upload-inventory-file">
                    <MuiButton
                        variant="outlined"
                        color="primary"
                        size="small"
                        startIcon={<CloudUploadIcon />}
                        component="span"
                    >
                        {file ? file.name : "Select File"}
                    </MuiButton>
                </label>
                <Typography
                    variant="caption"
                    color="textSecondary"
                    style={{ marginTop: 8, display: "block" }}
                >
                    Select an Excel file (.xlsx or .xls) containing your inventory.
                </Typography>
            </Box>

            <Box mt={3} textAlign="center">
                <Button
                    type="button"
                    color="rose"
                    size="sm"
                    style={{ marginRight: 8 }}
                    disabled={isConfirmDisabled}
                    onClick={handleConfirm}
                >
                    Confirm Upload
                </Button>
                <Button onClick={onClose} variant="outlined" size="sm">
                    Close
                </Button>
            </Box>
        </>
    );
}
